import React from 'react';
import {
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import { Helmet } from 'react-helmet-async';

const TermsAndConditions: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Helmet>
        <title>Syarat & Ketentuan Mabar - RaketerS</title>
      </Helmet>
      
      <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
        Syarat & Ketentuan Mabar RaketerS
      </Typography>
      
      <Paper sx={{ p: 4, mt: 3 }}>
        <List>
          <ListItem sx={{ display: 'block', pb: 2 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              1. Dokumentasi Kegiatan
            </Typography>
            <List sx={{ pl: 2 }}>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Selama acara Mabar, tim RaketerS berhak melakukan dokumentasi berupa foto maupun video."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Dokumentasi bukan kewajiban, namun tim akan mengusahakan adanya minimal 1 foto bersama."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Peserta menyetujui bahwa hasil dokumentasi dapat digunakan dan disebarluaskan untuk keperluan promosi, media sosial, atau publikasi lainnya tanpa kompensasi tambahan."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
            </List>
          </ListItem>

          <Divider sx={{ my: 2 }} />

          <ListItem sx={{ display: 'block', pb: 2 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              2. Penggunaan Kok
            </Typography>
            <List sx={{ pl: 2 }}>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Setiap match sudah termasuk 1 kok dalam biaya pendaftaran."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Setiap pemain berhak mendapatkan 3 kok untuk 3 match (1 match = 1 kok)."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Apabila dalam 1 sesi digunakan lebih dari jatah tersebut, maka dikenakan biaya tambahan sebesar Rp3.500 per kok."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
            </List>
          </ListItem>

          <Divider sx={{ my: 2 }} />

          <ListItem sx={{ display: 'block', pb: 2 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              3. Ketentuan Member
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Member bulanan mendapatkan:
            </Typography>
            <List sx={{ pl: 2 }}>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Hak melakukan reschedule tak terbatas waktu selama masa keanggotaan aktif."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Diskon jersey eksklusif untuk member elite."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
            </List>
          </ListItem>

          <Divider sx={{ my: 2 }} />

          <ListItem sx={{ display: 'block', pb: 2 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              4. Ketentuan Umum
            </Typography>
            <List sx={{ pl: 2 }}>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• Dengan mendaftar atau melakukan pembayaran, peserta dianggap telah membaca, memahami, dan menyetujui seluruh syarat & ketentuan ini."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'block', py: 0.5 }}>
                <ListItemText 
                  primary="• RaketerS berhak melakukan perubahan kebijakan sewaktu-waktu dengan tanpa pemberitahuan sebelumnya."
                  sx={{ '& .MuiListItemText-primary': { fontSize: '0.95rem' } }}
                />
              </ListItem>
            </List>
          </ListItem>
        </List>
      </Paper>
    </Container>
  );
};

export default TermsAndConditions;
